import { datatable } from '@/translations/en/common/datatable'
import { errors } from '@/translations/en/common/errors'
import { file } from '@/translations/en/common/file'
import { menu } from '@/translations/en/common/menu'
import { route } from '@/translations/en/common/route' //skip-export

export const common = {
  add: 'Add',
  select: 'Select',
  submit: 'Submit',
  notFound: 'Page not found',
  notFoundResult: 'Results not found',
  redirect: 'Redirecting...',
  success: 'Success',
  error: 'Error',
  invalidOrExpiredToken: 'Session expired. Please log in again',
  edit: 'Edit',
  delete: 'Delete',
  unknownError: 'An unknown error occurred',
  save: 'Save',
  confirm: 'Confirm',
  search: 'Search',
  filter: 'Filter',
  darkTheme: 'Enable dark theme',
  lightTheme: 'Enable light theme',
  validFrom: 'Valid from',
  label: 'Label',
  description: 'Description',
  code: 'Code',
  cancel: 'Cancel',
  restore: 'Restore',
  saveSuccess: 'Changes saved successfully',
  deleteSuccessGroup: 'Group deleted successfully',
  color: 'Color',
  yes: 'Yes',
  no: 'No',
  all: 'All',
  create: 'Create',
  sizes: 'Dimensions',
  length: 'Length',
  height: 'Height',
  width: 'Width',
  to: 'to',
  loading: 'Loading',
  saveChanges: 'Save changes',
  clearSelection: 'Clear',
  noItems: 'No data',
  expand: 'Expand',
  collapse: 'Collapse',
  close: 'Close',
  name: 'Name',
  count: 'Value',
  back: 'Back',
  errors: errors,
  menu: menu,
  file: file,
  datatable: datatable,
  route,
}
